__webpack_require__.p = "http://tuyensinh.dhcd.edu.vn/";